import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getMaquinas = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/maquinas?empresa=${userInfo.empresa}`);
       // console.log("MIS MAQUINAS " + JSON.stringify(data));
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearMaquina = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/maquinas', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateMaquina = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/maquinas/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteMaquina = (Id) => Axios.delete(`/maquinas/${Id}`);
